import React, {useState, useEffect} from "react";

import { Container, Title, TransferBehindContainer, TransferDataContainer, InfoContainer, ImageContainer, NameAndPlanContainer, FirstName, PlanName, AmountPill } from "./styles";

import { lastsTransfers } from "../../data/provisionalData";

//Assets
import payOrderYellow from "../../assets/icons/pay-order-yellow.svg";
import subscriptionYellow from "../../assets/icons/subscription-yellow.svg";

//Interface
import { DashboardLastTransferPropsInterface } from "./interfaces";

const DashboardLastTransfers = (props: DashboardLastTransferPropsInterface) => {
    const transferDataGenerator = () => {
        return props.transfers.map(transfer => {
            return(
                <React.Fragment key={`last_${transfer.id}`}>
                    <TransferDataContainer>
                        <div className="d-flex w-100 h-100">
                            <ImageContainer>
                                <img src={transfer.paymentType === "credit" ? subscriptionYellow : payOrderYellow}/>
                            </ImageContainer>
                            
                            <InfoContainer>
                                <div className="d-flex justify-content-end">
                                    <AmountPill>
                                        $ {parseFloat(transfer.amount).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}
                                    </AmountPill>
                                </div>
                                <NameAndPlanContainer>
                                    <FirstName>{transfer.firstName ? transfer.firstName : "Venda Avulsa"}</FirstName>
                                    <PlanName>{transfer.planName ? transfer.planName : ""}</PlanName>
                                </NameAndPlanContainer>
                            </InfoContainer>
                            
                        </div>
                    </TransferDataContainer>
                    <TransferBehindContainer/>
                </React.Fragment>
            )
        })
    }
    
    return(
        <Container>
            <div style={{marginBottom: 40}}>
                <Title>Últimas transações</Title>
            </div>

            {props.transfers.length  !== 0 ? transferDataGenerator() : null}
            
        </Container>
    )
}

export default DashboardLastTransfers;